import React from 'react';
import { Outlet } from 'react-router-dom';

import { liveUpdates } from '@/api/liveUpdates';
import { useAuthStore } from '@/api/login';
import { useTicker } from '@/theme';

export const StarterLayout = () => {
  const token = useAuthStore((state) => state.token);
  const source = useTicker();

  React.useEffect(() => {
    if (!token) return;
    liveUpdates.connect(token, source);
    return () => liveUpdates.disconnect();
  }, [token, source]);

  return <Outlet />;
};
